/**
 * Shop settings for online orders (minimum order, etc.).
 * Set when user proceeds to checkout; read by OrderCheckoutScreen.
 */
import AsyncStorage from '@react-native-async-storage/async-storage';

export const SHOP_SETTINGS_KEY = 'shopSettings';

export interface ShopSettings {
  minimum_order_cost?: number;
  [key: string]: unknown;
}

export async function getShopSettings(): Promise<ShopSettings | null> {
  try {
    const raw = await AsyncStorage.getItem(SHOP_SETTINGS_KEY);
    if (!raw) {return null;}
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export async function setShopSettings(settings: ShopSettings): Promise<void> {
  try {
    await AsyncStorage.setItem(SHOP_SETTINGS_KEY, JSON.stringify(settings));
  } catch {
    // ignore
  }
}
